import { parsePagesOldAsync } from './pdf-converter';
import { workerResolver } from './pdf-converter-optimized/Helpers';
import { workerTerminator, parsePagesOldAsync as parsePagesOptimizedAsync } from './pdf-converter-optimized';


const workerPaths = {
    old: '/scripts/dist/client/pdf-worker-old.client.bundle.js',
    optimized: '/scripts/dist/client/pdf-worker-optimized.client.bundle.js'
};

export const parseDocumentAsync = async (
    {
        password = null,
        useNewConverter = false,
        workerPath,
        ...params
    },
    awaitParser = false
) => {
    const workerUploadPath = workerPath || (useNewConverter ? workerPaths.optimized : workerPaths.old);
    const pdfWorker = new Worker(workerUploadPath);
    const instanceCreated = await workerResolver(pdfWorker, 'createInstance', password);
    const control = {
        terminate: () => workerTerminator(pdfWorker)
    };
    if (instanceCreated) {
        if (useNewConverter === true) {
            if (awaitParser) {
                await parsePagesOptimizedAsync(pdfWorker, params);
            } else {
                parsePagesOptimizedAsync(pdfWorker, params);
            }
        } else {
            if (awaitParser) {
                await parsePagesOldAsync(pdfWorker, params);
            } else {
                parsePagesOldAsync(pdfWorker, params);
            }
        }
    }
    return control;
};
